// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CreditMemoLedgerEntry } from './credit-memo-ledger-entry';
import { CreditMemoStatus } from './credit-memo-status';
import { CreditMemoType } from './credit-memo-type';
import { JoHeader } from './jo-header';
import { ReturnRequestDetail } from './return-request-detail';
import { CreditMemoStatusEnum } from './enums';
import { CreditMemoTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditMemo extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Decimal */
  creditMemoAmt!: number;
  /** Enum FK creditMemoStatus */
  creditMemoStatusId!: CreditMemoStatusEnum;
  /** Enum FK creditMemoType */
  creditMemoTypeId!: CreditMemoTypeEnum;
  /** String(100) */
  gLCreditMemoId?: string;
  /** Int32 FK joHeader */
  joHeaderId!: number;
  /** String */
  notes?: string;
  /** String(50) */
  refundTransactionId?: string;
  /** Decimal */
  restockChargeAmt?: number;
  /** Int32 FK returnRequestDetail */
  returnRequestDetailId?: number;
  /** String(50) */
  transactionId?: string;
  /** Boolean */
  wasAmtOverridden!: boolean;
  /** Inv FK creditMemoId */
  creditMemoLedgerEntries!: CreditMemoLedgerEntry[];
  /** FK creditMemoStatusId */
  creditMemoStatus!: CreditMemoStatus;
  /** FK creditMemoTypeId */
  creditMemoType!: CreditMemoType;
  /** FK joHeaderId */
  joHeader!: JoHeader;
  /** FK returnRequestDetailId */
  returnRequestDetail!: ReturnRequestDetail;
}

